import React from 'react';
import { useIntl } from 'react-intl';
import { Card, CardBody } from 'reactstrap';

import Breadcrumbs from 'src/enosikit/components/Breadcrumbs';
import Heading from 'src/enosikit/components/Heading';

/**
 * Loading skeleton for the Trade Rule List page.
 * Mirrors the layout of `TradeRuleList/index.jsx`: breadcrumbs, heading,
 * and grouped table sections per trade point.
 * @returns {React.ReactElement} Placeholder component.
 */
function Placeholder() {
  const intl = useIntl();

  const propertiesBreadcrumb = intl.formatMessage({
    id: 'trade_rule.trade_rule_list.placeholder.breadcrumbs.properties.label',
    defaultMessage: 'Properties',
  });
  const tradeRulesBreadcrumb = intl.formatMessage({
    id: 'trade_rule.trade_rule_list.placeholder.breadcrumbs.trade_rules.label',
    defaultMessage: 'Trade Rules',
  });
  const tradeRulesContext = intl.formatMessage({
    id: 'trade_rule.trade_rule_list.placeholder.heading.trade_rules.label',
    defaultMessage: 'Trade Rules',
  });

  return (
    <>
      <Breadcrumbs
        breadcrumbs={[
          { name: propertiesBreadcrumb, path: '/properties' },
          { name: <span className="placeholder placeholder-glow bg-darken" style={{ width: '10rem' }} /> },
          { name: tradeRulesBreadcrumb },
        ]}
      />
      <Heading
        title={<span className="placeholder placeholder-glow bg-darken" style={{ width: '12rem' }} />}
        subtitle={<span className="placeholder placeholder-glow bg-darken" style={{ width: '18rem' }} />}
        context={tradeRulesContext}
      />

      {[0, 1].map((groupIdx) => (
        <Card
          className="mt-4 mb-4"
          aria-hidden="true"
          key={`placeholder-trade-point-${groupIdx}`}
        >
          <CardBody>
            <h4>
              <span className="placeholder placeholder-glow bg-darken col-4" />
            </h4>
            <div className="table-responsive">
              <table className="table">
                <thead>
                  <tr>
                    {[0, 1, 2, 3].map((headIdx) => (
                      <th scope="col" key={`placeholder-tp-${groupIdx}-th-${headIdx}`}>
                        <span className="placeholder placeholder-glow bg-darken col-8" />
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {[0, 1, 2].map((rowIdx) => (
                    <tr key={`placeholder-tp-${groupIdx}-row-${rowIdx}`}>
                      {[0, 1, 2, 3].map((cellIdx) => (
                        <td key={`placeholder-tp-${groupIdx}-row-${rowIdx}-cell-${cellIdx}`}>
                          <span className="placeholder placeholder-glow bg-darken col-10" />
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </CardBody>
        </Card>
      ))}
    </>
  );
}

export default Placeholder;
